import React from "react";

import { BannerType } from "Components/Generic/Banner";
import _ from "lodash";
import { CiCircleCheck, CiCircleInfo, CiWarning } from "react-icons/ci";
import { PiWarningOctagonLight } from "react-icons/pi";

type TrackingStatus = "success" | "error" | "loading";

interface BannerInfo {
  label: string;
  type: BannerType;
}

export const mapBannerTypeByTrackingShipmentStatus = (
  status: string,
  shipmentTracking: any
): BannerInfo => {
  const conditionMap: Record<TrackingStatus, (data: any) => BannerInfo> = {
    success: (data) => {
      if (_.isEmpty(data)) {
        return {
          prefix: <PiWarningOctagonLight size={20} />,
          label:
            "No shipment information was found for the provided Bill of Landing or Booking #, but you can proceed with creating this shipment.",
          type: "warning",
        };
      }

      return {
        prefix: <CiCircleCheck size={20} />,
        label:
          "Shipment information has been retrieved for the provided Bill of Landing. Please review the details below for accuracy.",
        type: "positive",
      };
    },
    error: () => ({
      prefix: <CiWarning size={20} />,
      label:
        "An error occurred while fetching shipment details. Please contact Shipeezi support to report this issue for further investigation.",
      type: "negative",
    }),
    loading: () => ({
      prefix: <CiCircleInfo size={20} />,
      label: "Fetching shipment details.",
      type: "info",
    }),
  };

  const statusKey = status as TrackingStatus;

  return (conditionMap[statusKey] || conditionMap.loading)(shipmentTracking);
};
